import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import { useState, useRef, useEffect } from 'react';
import logo from '../img/UDM.png';
import {API_URL} from '../index';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import OrganisationList from './OrganisationList';
import SearchResults from './SearchResults';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import LinearProgress from '@material-ui/core/LinearProgress';
import ClearIcon from '@material-ui/icons/Clear';
import NewOrg from './NewOrg';
import Tooltip from '@material-ui/core/Tooltip';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Badge from '@material-ui/core/Badge';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
  },
  root_search: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    backgroundColor: '#f5f5f5',
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

function SearchField(props){
  const classes = useStyles();

  const [search_request, setSearchRequest] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState();
  const [fetching, setFetching] = useState();

  const searchRef = useRef();

  const Search = (request) => {
    setFetching(true)
    props.set_result(undefined);
    if (request.length < 3) {
      setError('Введите минимум три символа')
    } else if (request.length > 2) {
      setError('');
      const token = localStorage.getItem('token') != null ? 'Token ' + localStorage.getItem('token') : ''
      const organisation_url = API_URL + 'search_organisation/?search=' + request
      fetch(organisation_url, {
          method: 'GET',
          headers:{ 'Content-Type': 'application/json', 'Authorization': token }
          })
        .then(response => {props.set_page(response.url); return response.json()})
        .then(result => (setResult(result), props.set_result(result)))
        .then(e => setFetching(false))
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      Search(searchRef.current.value);
    }
  }

  return (
    <React.Fragment>
    <Paper className={classes.root_search}>
     <Tooltip title='Сбросить результаты поиска' placement='left'>
      <IconButton className={classes.iconButton} aria-label="menu" onClick={e => props.set_result(undefined)}>
        <MenuIcon />
      </IconButton>
      </Tooltip>
      <InputBase
        className={classes.input}
        name='search_request'
        placeholder="Найти..."
        inputProps={{ 'aria-label': 'search docs' }}
        inputRef={searchRef}
        onKeyPress={handleKeyPress}
      />
      <Tooltip title='Очистить строку' placement='bottom'>
        <ClearIcon onClick={e => searchRef.current.value = ''} style={{color: 'grey'}}/>
      </Tooltip>
      <Tooltip title='Найти' placement='right'>
      <IconButton className={classes.iconButton} aria-label="search" onClick={e => Search(searchRef.current.value)}>
        <SearchIcon />
      </IconButton>
      </Tooltip>
      <Divider className={classes.divider} orientation="vertical" />
    </Paper>
    {fetching ?
    <LinearProgress variant='query' style={{width: 407}}/>
    :
    <LinearProgress variant='buffer' style={{width: 407}}/>
    }
    <FormHelperText error>{error}</FormHelperText>
    </React.Fragment>
    )
}


export default function Main(props) {
  const classes = useStyles();

  const [result, setResult] = useState();
  const [user, setUser] = useState();
  const [archive, setArchive] = useState();
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [message, setMessage] = useState();
  const [page, setPage] = useState();
  const [refresh, setRefresh] = useState();

  const orgRef = useRef(null);

  useEffect(() => {
    localStorage.getItem('token') ?
    LoadUserArchiveInfo() :
    console.log('is guest user')
  }, []);

  const LoadUserArchiveInfo = () => {
      const user_url = API_URL + 'rest-auth/user'
      fetch(user_url, {
        method: 'GET',
        headers: { 'Authorization': 'Token ' + (token), 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then(data => (setUser(data), (

      fetch(API_URL + 'archive_by_user/?id=' + data.pk, {
        method: 'GET',
        headers: { 'Authorization': 'Token ' + (token), 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then(data => setArchive(data.results[0])) 

          )))
  }


  return (
    <div>
    <Container maxWidth='lg' className={classes.root}>
      <Paper fullWidth className={classes.root}>
        {/* <Typography variant="h5" component="h3">
           Местонахождение документов по личному составу
         </Typography>
         <Typography component="p">
           база данных
         </Typography> */}
        <Grid container>
        <Grid xs={4}>
        <SearchField set_result={setResult} set_page={setPage}/>
        </Grid>
        <Grid xs={3}>
        </Grid>
        <Grid xs={4}>
        </Grid>
        <Grid xs={1}>
        {token != undefined ?
        <NewOrg user={user} archive={archive} refresh={e => orgRef.current.update()} />:
        <div></div>
        }
        </Grid>
        </Grid>
        {result == undefined ?
        <OrganisationList user={user} archive={archive} page={page} ref={orgRef} />
        :
        <SearchResults result={result} user={user} archive={archive} page={page} ref={orgRef} />}
      </Paper>
    </Container>
    </div>
  );
}